/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaRicaricaStato } from './servizio-mensa-ricarica-stato';


export interface ServizioMensaRicaricheListFilter { 
    data_da?: string;
    data_a?: string;
    stato_interno?: ServizioMensaRicaricaStato;
    nominativo?: string;
    filtra_per_data_pagamento?: boolean;
}



